export default __webpack_public_path__ + "static/media/MagneticHill.abf532e4.jpg";